import styled from 'styled-components';
import {
  MIN_PC_BODY_WIDTH,
  MIN_TABLET_BODY_WIDTH,
} from '../../constants/StylistConstants';

export const BaseButton = styled.div`
  text-align: center;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 20px;
  border: 1px solid #000000;

  background: #000000;

  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  text-transform: lowercase;

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    font-size: 14px;
    line-height: 21px;
  }

  color: #ffffff;
`;

export const BuyLookButton = styled(BaseButton)`
  width: 243px;
  height: 64px;

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    width: 154px;
    height: 45px;
    font-size: 14px;
    line-height: 21px;
  }
`;

export const BuyGarmentButton = styled(BaseButton)`
  width: 234px;
  height: 64px;

  @media (max-width: ${MIN_PC_BODY_WIDTH - 1}px) {
    width: 172px;
    height: 45px;
    font-size: 14px;
    line-height: 21px;
  }
`;
